<section>
    <div class="wrapper">
        <article class="mrt-75">
            <div class="camera-list-component">
                <mat-grid-list cols="3" rowHeight="70px" class="header-grid">
                    <mat-grid-tile>
                        <span class="header">Camera List</span>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field appearance="legacy" class="mat-searchbar">
                            <span matPrefix> </span>
                            <input type="text" matInput placeholder="Search" name="searchCameraFilterValue"
                                (ngModelChange)="searchTerms.next($event);" [(ngModel)]="searchCameraFilterValue">
                            <button mat-button *ngIf="searchCameraFilterValue" matSuffix mat-icon-button
                                aria-label="Clear" (click)="clearSearchFilter()">
                                <mat-icon>close</mat-icon>
                            </button>
                            <button matSuffix mat-button class="serach-button-icon"><mat-icon>search</mat-icon></button>
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="bottom-button">
                            <button mat-raised-button class="remove-btn"
                                *ngIf="this.selection.selected.length !== 0 && editCameraConfig"
                                (click)="removeCamera()">
                                <mat-icon aria-hidden="false" aria-label="delete icon">delete</mat-icon>
                                Remove
                            </button>
                            <!-- <button mat-raised-button class="edit-btn" (click)="editCamera()">
                                <mat-icon aria-hidden="false" aria-label="add icon">mode_edit_outline</mat-icon>
                                Edit
                            </button> -->
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
            </div>
            <div class="camera-list-table">
                <div class="mat-elevation-z8 table-pagination">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort matSortActive="created"
                        matSortDisableClear matSortDirection="desc">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef class="table-header">
                                <!-- <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox> -->
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" disabled="{{row.isNewCamServer}}"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- unique_id Column -->
                        <ng-container matColumnDef="unique_id">
                            <th mat-header-cell *matHeaderCellDef> Cam Unique ID </th>
                            <td mat-cell *matCellDef="let element; let i= index;"> {{element.camUniqueId}} </td>
                        </ng-container>

                        <!-- camera_id Column -->
                        <!-- <ng-container matColumnDef="camera_id">
                            <th mat-header-cell *matHeaderCellDef> Camera ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.cameraId}} </td>
                        </ng-container> -->

                        <!-- camera_name Column -->
                        <ng-container matColumnDef="camera_name">
                            <th mat-header-cell *matHeaderCellDef> Camera Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.cameraName}} </td>
                        </ng-container>

                        <!-- camera_type Column -->
                        <ng-container matColumnDef="camera_type">
                            <th mat-header-cell *matHeaderCellDef> Camera Type </th>
                            <td mat-cell *matCellDef="let element"> {{element.cameraType}} </td>
                        </ng-container>

                        <!-- site_name Column -->
                        <!-- <ng-container matColumnDef="site_name">
                            <th mat-header-cell *matHeaderCellDef> Site Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.site_name}} </td>
                        </ng-container> -->

                        <!-- PTZ Column -->
                        <ng-container matColumnDef="PTZ">
                            <th mat-header-cell *matHeaderCellDef> PTZ </th>
                            <td mat-cell *matCellDef="let element"> {{element.isPTZ}} </td>
                        </ng-container>

                        <!-- active Column -->
                        <ng-container matColumnDef="active">
                            <th mat-header-cell *matHeaderCellDef> Active </th>
                            <td mat-cell *matCellDef="let element"> {{element.active}} </td>
                        </ng-container>

                        <!-- active Column -->
                        <ng-container matColumnDef="analytic_name">
                            <th mat-header-cell *matHeaderCellDef> Analytic Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.analyticName}} </td>
                        </ng-container>

                        <!-- connected Column -->
                        <ng-container matColumnDef="connected">
                            <th mat-header-cell *matHeaderCellDef> Status </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="element.connected === true" matTooltip="Connected"
                                    class="up-status"></span>
                                <span *ngIf="element.connected === false" matTooltip="Not Connected"
                                    class="down-status"></span>
                            </td>
                        </ng-container>

                        <!-- action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-raised-button class="edit-btn" (click)="editCamera(element)"
                                    disabled="{{!element?.isNewCamServer}}"
                                    matTooltip="{{!element?.isNewCamServer ? 'You cannot edit old camera server' : (element.isNewCamServer && !editCameraConfig) ? 'View Camera' : 'Edit camera'}}">
                                    <mat-icon aria-hidden="false" *ngIf="element.isNewCamServer && editCameraConfig"
                                        aria-label="add icon">mode_edit_outline</mat-icon>
                                    <mat-icon aria-hidden="false" *ngIf="element.isNewCamServer && !editCameraConfig"
                                        aria-label="view icon">visibility
                                    </mat-icon>
                                    <mat-icon aria-hidden="false" *ngIf="!element.isNewCamServer"
                                        aria-label="view icon">mode_edit_outline
                                    </mat-icon>
                                </button>
                                <button mat-raised-button color="primary" class="edit-btn" style="margin-left: 5px;"
                                    *ngIf="isLiveViewEnabled" (click)="liveView($event, element)"
                                    matTooltip="Live View">
                                    <mat-icon aria-hidden="false" aria-label="live view">play_arrow</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectedRow($event,row)">
                        </tr>
                    </table>
                    <div class="no_record_found_msg" *ngIf="dataSource.data.length === 0">
                        No Records Found!
                    </div>
                    <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize"
                        [length]="totalRecords" [pageIndex]="pageIndex" (page)="changePaging($event)"
                        aria-label="Select page of users">
                    </mat-paginator>
                </div>
            </div>
        </article>
    </div>
</section>